import 'react-toastify/dist/ReactToastify.css';

const MainLayout = (props) =>  {
    return(
        <>
            {props.children}
        </>
    )
}

export default MainLayout
